import {useState, useEffect} from "react";
import styles from "./ProfilePersonalDetails.module.css";
import {useLocation } from "react-router-dom";

const ProfilePersonalDetails = () => {
  const [user, setUser] = useState(JSON.parse(localStorage.getItem("auth")));
  const location = useLocation();

  useEffect(() => {
    setUser(JSON.parse(localStorage.getItem("auth")));
  }, [location]);

  const formData = {
    firstName: user.result.firstName,
    lastName: user.result.lastName,
    email: user.result.email,
    password: user.result.password,
    confirmPassword: user.result.confirmPassword,
    currentPassword: user.result.currentPassword,
    address: user.result.address,
    city: user.result.city,
    state: user.result.state,
    pincode: user.result.pincode,
    landmark: user.result.landmark,
    instagramHandle: user.result.instagramHandle,
    countryCode: user.result.countryCode,
    mobile: user.result.mobile,
  }

  const [form, setForm] = useState(formData);

  const handleSubmit = () => {
    
  }


  return (
    <div className={styles["ProfilePersonalDetails__container"]}>
      <form className={styles["ProfilePersonalDetails__FormContainer"]}>
        <div className={styles["ProfilePersonalDetails-section1"]}>
          <img
            src="https://i.pinimg.com/originals/51/f6/fb/51f6fb256629fc755b8870c801092942.png"
            alt="Fodrix"
            width="100px"
            height="100px"
          />
          <div
            className={
              styles["ProfilePersonalDetails-section1__inputContainer"]
            }
          >
            <div>
              <label htmlFor="profileFirstName">First Name</label>
              <input
                // className={styles["popup__TextField"]}
                type="text"
                name="firstName"
                id="profileFirstName"
                value={user.result.firstname}
              />
            </div>
            <div>
              <label htmlFor="profileLastName">Last Name</label>
              <input
                // className={styles["popup__TextField"]}
                type="text"
                name="LastName"
                id="profileLastName"
                value={user.result.lastname}
              />
            </div>
          </div>
        </div>
        <div className={styles["ProfilePersonalDetails-section2"]}>
          <label htmlFor="profileEmail">Email</label>
          <input
            // className={styles["popup__TextField"]}
            type="text"
            name="Email"
            id="profileEmail"
            value={user.result.email}
            disabled
          />
        </div>
        <div className={styles["ProfilePersonalDetails-section3"]}>
          <div>
            <label htmlFor="profileCountryCode">Country code</label>
            <input
              // className={styles["popup__TextField"]}
              type="text"
              name="CountryCode"
              id="profileCountryCode"
            />
          </div>
          <div>
            <label htmlFor="profilePhoneNumber">Phone number</label>
            <input
              // className={styles["popup__TextField"]}
              type="text"
              name="PhoneNumber"
              id="profilePhoneNumber"
              value={user.result.mobile}
            />
          </div>
        </div>
        <div className={styles["ProfilePersonalDetails-section4"]}>
          <label htmlFor="profileInsta">Instagram Handle</label>
          <input
            // className={styles["popup__TextField"]}
            type="text"
            name="InstagramHandle"
            id="profileInsta"
          />
        </div>
        <button onClick={handleSubmit} className={styles["ProfilePersonalDetails-button"]}>
          Save changes
        </button>
      </form>
    </div>
  );
};

export default ProfilePersonalDetails;
